/* ZFF general inquiries and contact intent. Existing Google channel owns GA4. */
(function () {
  'use strict';
  if (window.__zffSiteMeasurement || (window.Shopify && window.Shopify.designMode)) return;
  window.__zffSiteMeasurement = true;
  var gaId = 'G-WHG1LBTB9W';
  var key = 'zff_general_inquiry_pending_v1';
  var attributionKey = 'zff_buyer_attribution_v1';
  var ttl = 30 * 60 * 1000;
  var queue = [];
  function allowed() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return navigator.globalPrivacyControl !== true && p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed();
  }
  function read(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function remove(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function write(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  function campaign() {
    if (!allowed()) return '';
    var a = read(attributionKey), values = a && Date.now() - a.at < ttl ? a.values || {} : {};
    return ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].filter(function (k) {
      return typeof values[k] === 'string' && /^[a-zA-Z0-9_. -]{1,120}$/.test(values[k]);
    }).map(function (k) { return k + '=' + values[k]; }).join('; ');
  }
  function drain() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (navigator.globalPrivacyControl !== true && (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function')) return;
    if (!allowed()) { queue = []; remove(key); return; }
    if (typeof window.gtag !== 'function') return;
    while (queue.length) {
      var event = queue.shift();
      if (event.id) {
        var sentKey = 'zff_general_inquiry_sent_' + event.id;
        if (read(sentKey) || !write(sentKey, true)) continue;
      }
      window.gtag('event', event.name, Object.assign({ send_to: gaId }, event.params));
    }
  }
  function emit(name, params, id) {
    if (!allowed()) return;
    queue.push({ name: name, params: params, id: id }); drain();
  }
  function start() {
    document.querySelectorAll('[data-zff-general-contact]').forEach(function (form) {
      if (form.querySelector('[data-zff-general-contact-success]')) {
        var pending = read(key);
        if (pending && pending.path === window.location.pathname && Date.now() - pending.at < ttl) {
          queue.push({ name: 'zff_contact_inquiry_submitted', params: { inquiry_type: 'general_contact', event_id: pending.id }, id: pending.id });
        }
      }
      form.addEventListener('submit', function () {
        if (!form.checkValidity() || !allowed()) { remove(key); return; }
        var id = window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
        write(key, { id: id, at: Date.now(), path: window.location.pathname });
        var reference = form.querySelector('[data-zff-general-reference]');
        var source = form.querySelector('[data-zff-general-attribution]');
        if (reference) reference.value = id;
        if (source) source.value = campaign();
      });
    });
    document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (/^(mailto:|tel:)/i.test(href)) {
        emit('zff_contact_click', { contact_method: /^mailto:/i.test(href) ? 'email' : 'phone' });
        return;
      }
      try {
        var url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) return;
        if (/^\/pages\/(wholesale-pasta-salad-supplier|private-label-pasta-salad-manufacturer)\/?$/.test(url.pathname)) {
          emit('zff_buyer_interest', { program: url.pathname.indexOf('private-label') >= 0 ? 'private_label' : 'wholesale' });
        }
      } catch (e) {}
    });
    document.addEventListener('visitorConsentCollected', drain);
    var attempts = 0, timer = window.setInterval(function () { drain(); if (++attempts >= 60) window.clearInterval(timer); }, 1000);
    drain();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
